import {Injectable} from '@angular/core';
import {ListenerGroup, onKeyboardViewportChange, revealFocusedInScroller} from '../shared/keyboard-viewport.util';

const DIALOG_SELECTOR = '.mydocma-dialog-xs-fullscreen, .mydocma-mm-fault-pane-dialog';

// iOS pans the page up on focus to clear the keyboard, leaving white below. For these cdk dialogs the pan
// is a window scroll, so we pin scrollY back to 0 (scoped to an open dialog so normal pages aren't yanked).
// Pinning to 0 can hide a low field, so we keep the focused field visible via the dialog's OWN inner scroller
// (visible bottom = min(scroller bottom, vv.height); the scroller can extend behind the keyboard).
// Not covered: visual-viewport-only pans (vv.offsetTop > 0, scrollY stays 0) — scrollTo can't reach those.
@Injectable({providedIn: 'root'})
export class MmKeyboardDialogAnchorService {

  private listeners = new ListenerGroup();

  start(): void {
    if (this.listeners.active || typeof window === 'undefined' || !window.visualViewport) {
      return;
    }
    onKeyboardViewportChange(this.listeners, () => this.update());
  }

  stop(): void {
    this.listeners.clear();
  }

  private update(): void {
    const vv = window.visualViewport;
    if (!vv) {
      return;
    }
    const dialogOpen = !!document.querySelector(DIALOG_SELECTOR);
    if (vv.offsetTop > 0 && window.scrollY !== 0 && dialogOpen) {
      window.scrollTo(0, 0);
    }
    if (vv.offsetTop > 0 && dialogOpen) {
      revealFocusedInScroller(vv);
    }
  }
}
